var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOperate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 5H1V10H6V5ZM0 4V11H3L3 18.5C3 19.8807 4.11929 21 5.5 21H13.0354C13.2781 22.6961 14.7368 24 16.5 24C18.433 24 20 22.433 20 20.5C20 18.567 18.433 17 16.5 17C14.7368 17 13.2781 18.3039 13.0354 20H5.5C4.67158 20 4 19.3284 4 18.5V11H7V4H0ZM14 20.5C14 21.8807 15.1193 23 16.5 23C17.8807 23 19 21.8807 19 20.5C19 19.1193 17.8807 18 16.5 18C15.1193 18 14 19.1193 14 20.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2572 3.33724C12.924 3.13728 12.5 3.37734 12.5 3.76599V12.2336C12.5 12.6223 12.924 12.8623 13.2572 12.6624L20.3136 8.42854C20.6373 8.23434 20.6373 7.76525 20.3136 7.57105L13.2572 3.33724ZM11.5 3.76599C11.5 2.60005 12.772 1.87988 13.7717 2.47975L20.8281 6.71356C21.7991 7.29616 21.7991 8.70343 20.8281 9.28604L13.7717 13.5198C12.772 14.1197 11.5 13.3995 11.5 12.2336V3.76599Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperate);
export default __webpack_public_path__ + "static/media/operate.2751f96b.svg";
export { ForwardRef as ReactComponent };